import { jsx as _jsx } from "react/jsx-runtime";
export const Line = ({ x = 0, y = 0, width = 1, length, tint, angle = 0 }) => (_jsx("graphics", { x: x, y: y, angle: angle, draw: (graphics) => {
        graphics.clear();
        graphics.moveTo(0, 0).lineTo(length, 0).stroke({ width, color: tint });
    } }));
//# sourceMappingURL=Line.js.map